import React from "react"
import { render } from "react-dom"
import Orchestrator from "f3-admin-orchestrator/lib"
import custom from "./custom"

render(
  <Orchestrator
    vars = { process.vars }
    custom = { custom }
  />,
  document.getElementById("root")
)

export default Orchestrator



// WEBPACK FOOTER //
// src/client.js